import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Skip-to-content link (FR-040): the first focusable element in the shell;
 * activating it moves focus to the content region.
 */
@Component({
  selector: 'app-skip-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a class="skip-link" [href]="'#' + targetId()" (click)="skip($event)">Skip to content</a>
  `,
})
export class SkipLinkComponent {
  /** Id of the content region to move focus to. */
  readonly targetId = input<string>('content');

  skip(event: Event): void {
    event.preventDefault();
    document.getElementById(this.targetId())?.focus();
  }
}
